import React, { useEffect } from 'react';
// nodejs library that concatenates classes
import classNames from 'classnames';
// @material-ui/core components
import { makeStyles } from '@material-ui/core/styles';
// core components
import Header from '../../components/UI/Header/Header';
import HeaderLinks from '../../components/UI/Header/HeaderLinks';
import GridContainer from '../../components/UI/Grid/GridContainer';
import GridItem from '../../components/UI/Grid/GridItem';
import Footer from '../../components/UI/Footer/Footer';
// img
import bg01 from '../../assets/img/bg01.jpg';
import profile01 from '../../assets/img/profile01.jpg';
import profile02 from '../../assets/img/profile02.jpg';

import errorPageStyle from '../../assets/jss/coscef/views/errorPageStyle';

const useStyles = makeStyles(errorPageStyle);

const NetworkErrorPage = ({ ...rest }) => {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
  });
  const classes = useStyles();

  return (
    <div>
      <Header
        brand='CoScef'
        links={<HeaderLinks dropdownHoverColor='dark1' />}
        fixed
        color='transparent'
        changeColorOnScroll={{
          height: 100,
          color: 'dark',
        }}
        {...rest}
      />
      <div
        className={classes.pageHeader}
        style={{
          backgroundImage: 'url(' + bg01 + ')',
          backgroundSize: 'cover',
          backgroundPosition: 'top center',
        }}
      >
        <div className={classes.contentCenter}>
          <GridContainer>
            <GridItem md={12}>
              <h1 className={classes.title}>500</h1>
              <h2 className={classes.subTitle}>
                Ocurrió un error en la conexión :(
              </h2>
              <h4 className={classes.description}>
                Ooooups! El servidor puede que este caído, inténtelo mas tarde.
              </h4>
            </GridItem>
          </GridContainer>
        </div>
      </div>
      <Footer
        theme='dark'
        content={
          <div className={classNames(classes.pullCenter, classes.copyRight)}>
            &copy; {1900 + new Date().getYear()}{' '}
            <a href='https://www.coscef.co.cu' className={classes.aClasses}>
              <b>CoScef</b>
            </a>{' '}
            Todos los Derechos Reservados.
          </div>
        }
      >
        <GridContainer>
          <GridItem xs={12} sm={4} md={4}>
            <h5>Contactenos a través de:</h5>
            <div className={classes.socialFeed}>
              <div>
                <i className='fa fa-phone-square fa-lg' />
                <p>24 480558, 53784162 y 58396621</p>
              </div>
              <div>
                <i className='fab fa-whatsapp' />
                <p>53784162 y 58396621</p>
              </div>
              <div>
                <i className='fa fa-envelope-square fa-lg' />
                <p>elbalan@nauta.cu o elbalan65@gmail.com</p>
              </div>
            </div>
            <p>
              Marcando la diferencia a partir de los atributos: Experiencia,
              Competitividad, Calidad y Liderazgo.{' '}
            </p>
          </GridItem>
          <GridItem xs={12} sm={4} md={4}>
            <h5>Redes sociales</h5>
            <div className={classes.socialFeed}>
              <div>
                <i className='fab fa-facebook-square' />
                <p>Canal de facebook.</p>
              </div>
              <div>
                <i className='fab fa-telegram' />
                <p>Canal de telegram.</p>
              </div>
              <div>
                <i className='fab fa-twitter' />
                <p>Canal de twitter.</p>
              </div>
            </div>
          </GridItem>
          <GridItem xs={12} sm={4} md={4}>
            <h5>Grupo de trabajo</h5>
            <div className={classes.galleryFeed}>
              <img
                src={profile01}
                className={classNames(
                  classes.img,
                  classes.imgRaised,
                  classes.imgRounded
                )}
                alt='...'
              />
              <img
                src={profile02}
                className={classNames(
                  classes.img,
                  classes.imgRaised,
                  classes.imgRounded
                )}
                alt='...'
              />
            </div>
          </GridItem>
        </GridContainer>
      </Footer>
    </div>
  );
};

export default NetworkErrorPage;
